import { z } from 'zod';
import { SHIP_TERMS_CONSTRAINTS } from './constraints.js';
export const shipTermsFormSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, `${SHIP_TERMS_CONSTRAINTS.name.label} is required.`)
        .max(SHIP_TERMS_CONSTRAINTS.name.maxLength),
});
//# sourceMappingURL=create-form.js.map